import { Input } from '../ui/input'
import { useFieldContext } from '@/lib/form'
import {
  Field,
  FieldDescription,
  FieldError,
  FieldLabel,
} from '@/components/ui/field'
import { cn } from '@/lib/utils'

type ClassNames = {
  input?: string
}

export function TextField({
  label,
  htmlFor,
  type,
  autoComplete,
  placeholder,
  description,
  classNames,
  ...inputProps
}: {
  label: string
  htmlFor: string
  type?: React.InputHTMLAttributes<HTMLInputElement>['type']
  autoComplete?: string
  placeholder?: string
  description?: string
  classNames?: ClassNames
} & Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type' | 'autoComplete' | 'placeholder' | 'className' | 'id' | 'name' | 'value' | 'onChange' | 'onBlur'
>) {
  const field = useFieldContext<string>()

  return (
    <Field>
      <div>
        <FieldLabel htmlFor={htmlFor}>{label}</FieldLabel>
        {description && <FieldDescription>{description}</FieldDescription>}
      </div>
      <div>
        <Input
          className={cn(classNames?.input, {
            'border-red-500 focus-visible:ring-red-500':
              field.state.meta.errors.length > 0,
          })}
          id={htmlFor}
          name={field.name}
          type={type}
          autoComplete={autoComplete}
          value={field.state.value}
          onChange={(e) => field.handleChange(e.target.value)}
          onBlur={field.handleBlur}
          placeholder={placeholder}
          {...inputProps}
        />
        <FieldError errors={field.state.meta.errors} />
      </div>
    </Field>
  )
}
